import { ProviderRoleId, useCurrentRole } from '../currentRole'
import { usePersistedState } from '../api/localStore'

export type CaseloadView = 'all' | 'therapist' | 'nutritionist' | 'psychiatrist'

export const CASELOAD_VIEWS: { id: CaseloadView; label: string }[] = [
  { id: 'all', label: 'All' },
  { id: 'therapist', label: 'Therapist' },
  { id: 'nutritionist', label: 'Nutritionist' },
  { id: 'psychiatrist', label: 'Psychiatrist' },
]

const viewForRole = (role: ProviderRoleId): CaseloadView =>
  role === 'therapist' || role === 'nutritionist' ? role : 'all'

export const useCaseloadView = (): [CaseloadView, (view: CaseloadView) => void] => {
  const [role] = useCurrentRole()
  const [chosen, setChosen] = usePersistedState<CaseloadView | null>('advanced.caseloadView.v1', null)

  return [chosen ?? viewForRole(role), setChosen]
}

// Therapy stalls show as Standard's days-disengaged chip instead.
export const showsStalledTrack = (view: CaseloadView, ownerRole: string | null): boolean =>
  ownerRole !== 'therapist' && (view === 'all' || view === ownerRole)
